<template>
  <Attribute
    v-if="type !== 'photo' && type !== 'illustration'"
    :label="$t('Choose template color')"
    :is-required="true"
    :attributes="attributes.color"
    attribute-name="color"
    classes="colors"
  />
  <Rotation />
  <Attribute
    :label="$t('Choose table size')"
    :is-required="true"
    :attributes="attributes.size"
    attribute-name="size"
    classes="sizes"
  />
  <Attribute
    :label="$t('Choose stand')"
    :is-required="true"
    :attributes="attributes.stand"
    attribute-name="stand"
    classes="stands grid"
  />
  <StandText v-if="showStandText" />
  <Attribute
    :label="$t('Choose packaging')"
    :is-required="true"
    :attributes="attributes.packaging"
    attribute-name="packaging"
    classes="packagings"
  />
  <PackagingText v-if="showPackagingText" />
</template>
<script>
import { mapGetters } from "vuex";
import Attribute from "./Attribute";
import StandText from "./StandText";
import PackagingText from "./PackagingText";
import Rotation from "../Rotation";
import useProduct from "../../useProduct";

export default {
  components: {
    Attribute,
    StandText,
    Rotation,
    PackagingText,
  },
  props: {
    type: {
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      attributes: "product/getAttributes",
    }),
  },
  setup() {
    const { showStandText, showPackagingText } = useProduct();

    return {
      showStandText,
      showPackagingText,
    };
  },
};
</script>
